import type { SportMenuItemNative } from 'app/modules/Navigation/types';

import type { MatchesBySportId } from './get-filtered-matches-by-time-filter';

export const getFilteredSportsMenuItemsByTimeFilter = (
  sportItems: SportMenuItemNative[],
  matches: MatchesBySportId,
): SportMenuItemNative[] => {
  const filteredSportItemsByStartDate: SportMenuItemNative[] = [];

  sportItems.forEach((sportItem) => {
    const filteredMatchByStartDate = matches[sportItem.sportId];

    if (filteredMatchByStartDate) {
      filteredSportItemsByStartDate.push({
        ...sportItem,
        entity: {
          ...sportItem.entity,
          matchIds: filteredMatchByStartDate,
          matchesCount: filteredMatchByStartDate.size,
        },
      });
    }
  });

  return filteredSportItemsByStartDate;
};
